import { headerApiService } from "../api-services/headerApiServices";
import { useCustomQuery } from "../hooks/useFetch";

const useCommon = () => {
    const { data: cityList } = useCustomQuery(
        "cityList",
        headerApiService.getCityList
    );

    return {
        cityLists: cityList?.data,
        isCityLoading: cityList?.isLoading,
        cityError: cityList?.error,
    };
};

export default useCommon;
